import { render, staticRenderFns } from "./CaisseCard.vue?vue&type=template&id=5dabd87f&"
import script from "./CaisseCard.vue?vue&type=script&lang=js&"
export * from "./CaisseCard.vue?vue&type=script&lang=js&"
import style0 from "./CaisseCard.vue?vue&type=style&index=0&id=5dabd87f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports